import jsPDF from "jspdf";
import "jspdf-autotable";
import * as style from "./Challanreportstyle"; 

/**
 * ChallanPage.js — RA Masale "Delivery challan" format
 * ------------------------------------------------------------------
 * Entry point, same role as your Tax Invoice Page.js: builds the
 * jsPDF doc, calls the header/body/footer drawing functions in
 * order, then opens the PDF.
 *
 * `companyDetails` = seller letterhead info NOT guaranteed to be in
 * your challan API response (company name, address, branch address,
 * GSTIN). Pass it in from your company/theme settings, same as the
 * invoice report — see the note in ChallanReportStyle.js for where
 * this should come from.
 * ------------------------------------------------------------------
 */

const pageHeder = (doc, data, companyDetails) => {
    style.pageBorder(doc);
    style.pageHeder(doc, data, companyDetails);
    let y = style.reportPartyAndChallanInfo(doc, data);
    y = style.reportOrderingText(doc, y);
    return y;
};

const FOOTER_MIN_Y = 700;

const reportBody = (doc, data, headerBottomY, companyDetails) => {
    const tableEndY = style.tableBody(doc, data, headerBottomY);
    const footerStartY = Math.max(tableEndY, FOOTER_MIN_Y);
    style.reportFooterTotals(doc, data, footerStartY, companyDetails);
};

const pageFooter = (doc) => {
    style.pageFooter(doc);
};

const DeliveryChallanReport_RAMasale = (data, companyDetails) => {
    const doc = new jsPDF("p", "pt", "a4");

    const headerBottomY = pageHeder(doc, data, companyDetails);
    reportBody(doc, data, headerBottomY, companyDetails);
    pageFooter(doc);

    doc.setProperties({
        title: `DeliveryChallan/${data.ChallanDate}-${data.PartyName}`,
    });

    const pdfUrl = URL.createObjectURL(doc.output("blob"));
    window.open(pdfUrl);
};

export default DeliveryChallanReport_RAMasale;